import omit from 'lodash/omit'
import { useEffect } from 'react'
import { useLocation } from 'react-router'

import { getRouteParams } from '../utils/routeParams'
import { getSimplifiedRouteNameForSegmentTracking, useSegment } from './useSegment'

export const HASH_ROUTER_LOAD_SAFETY_TIMEOUT = 400

export const useSegmentPageEvent = () => {
  const location = useLocation()
  const { page: segmentPage } = useSegment()

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // The compat router match adds a '*' splat for wildcard routes. It is a routing artifact,
      // not a route param — the simplifier treats every string param value as an id to redact,
      // so keeping it would collapse whole route names (e.g. "settings/organization/vat_rates"
      // would become "settings/id").
      const routeParams = omit(getRouteParams(), '*')

      const route = getSimplifiedRouteNameForSegmentTracking(location, routeParams)
      segmentPage({ payload: { route } })
    }, HASH_ROUTER_LOAD_SAFETY_TIMEOUT)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [location, segmentPage])
}
